import React, { useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import BarchartComparativa from "components/chart/BarChartComparativa";
import { Col, Row } from "reactstrap";
import Select from "react-select";
import { avantSolarApi } from "api/authApi";
import { useSelector } from "react-redux";
import Alert from "components/alert";
import SpinnerAvantsolar from "components/utils/spinner";
import { tamanioGrafica } from "utils/generalFunctions";
import { convertirFechaInputFecha } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";

var ps;

function GraficaComparativaProduccion(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [datosGrafica, setDatosGrafica] = useState([]);
  const [loading, setLoading] = useState(false);
  const [titulo, setTitulo] = useState(null);

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  let tipoOptions = [
    { value: "inversor", label: "Inversores", color: "#00B8D9" },
    { value: "instalacion", label: "Instalaciones", color: "#0052CC" },
  ];

  let potenciaOptions = [
    { value: "100000", label: "100", color: "#00B8D9" },
    { value: "60000", label: "60", color: "#0052CC" },
    { value: "40000", label: "40", color: "#0052CC" },
    { value: "30000", label: "30", color: "#0052CC" },
    { value: "20000", label: "20", color: "#0052CC" },
    { value: "15000", label: "15", color: "#0052CC" },
    { value: "10000", label: "10", color: "#0052CC" },
    { value: "5000", label: "5", color: "#0052CC" },
  ];

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let tipo = event.target.tipo.value;
    let potencia = event.target.potencia.value;
    let dia = event.target.fecha.value.substring(8, 10);
    let mes = event.target.fecha.value.substring(5, 7);
    let anio = event.target.fecha.value.substring(0, 4);
    let consulta = `&potencia=${potencia}&fecha=${anio}${mes}${dia}&tipo=${tipo}`;

    fetchDatosGrafica(consulta);
  };

  const fetchDatosGrafica = async (consulta) => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        `/admins/dailyGraphicComparation?id_huerta=${huerta}` + consulta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      setLoading(false);
      console.log(data);
      if (data?.code == 200) {
        setDatosGrafica([...data.data.datos]);
        setTitulo(data.data.titulo);
        if (data.data.datos.length == 0) {
          setError("No hay datos para esta consulta");
        }
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error?.response?.message);
    }
  };

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div className="p-2">
            {loading && <SpinnerAvantsolar></SpinnerAvantsolar>}
            {error && (
              <div style={{ height: `${tamanioGrafica()}px` }}>
                <Alert message={error}></Alert>
              </div>
            )}
            {titulo && <p className="text-center">{titulo}</p>}
            {!error && <BarchartComparativa dataGrafica={datosGrafica} />}
          </div>
          <div>
            <form
              onSubmit={(event) => {
                handleSubmitForm(event);
              }}
              className="w-100"
            >
              <Row className="w-100 p-0 m-0 mt-5 mt-lg-3">
                <Col
                  xs={12}
                  xl={5}
                  className="w-100 d-flex justify-content-center justify-content-sm-end align-items-center mt-3"
                >
                  <label className="d-flex justify-content-center align-items-center w-100">
                    Mostrar día:
                    <input
                      max={convertirFechaInputFecha(
                        new Date().toLocaleDateString()
                      )}
                      required
                      className="w-75 p-1 ml-2"
                      name="fecha"
                      type="date"
                    />
                  </label>
                </Col>
                <Col
                  xs={12}
                  xl={5}
                  className="w-100 d-flex justify-content-center  align-items-center mt-3"
                >
                  <label className="w-50 flex">
                    Selecciona:
                    <Select
                      defaultValue={tipoOptions[0]}
                      menuPlacement="top"
                      className="basic-single mr-3"
                      classNamePrefix="select"
                      name="tipo"
                      options={tipoOptions}
                    />
                  </label>
                  <label className="w-50">
                    Potencia (KWH):
                    <Select
                      defaultValue={potenciaOptions[0]}
                      menuPlacement="top"
                      className="basic-single"
                      classNamePrefix="select"
                      name="potencia"
                      options={potenciaOptions}
                    />
                  </label>
                </Col>
                <Col
                  xs={12}
                  xl={2}
                  className="w-100 d-flex justify-content-center justify-content-sm-start aling-items-center mt-3"
                >
                  <button className="btn btn-primary btn-noPadding ml-2">
                    Enviar
                  </button>
                </Col>
              </Row>
            </form>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default GraficaComparativaProduccion;
